export const addPxPostfix = (value: number): string => {
    return value + "px";
};
